import api from "./api";

export async function getContent(field= '', paginate = false, currentPage = 1) {
    return await api.get(`/contents?&paginate=${paginate}&page=${currentPage}`)
}

export function getContentId(id) {
    return api.get(`/contents/${id}`)
}

export function setContent(data) {
    return api.post('/contents', data)
}

export function editContent(id, data) {
    return api.put(`/contents/${id}`, data)
}
